<template>
  <div class="main-link h-24 relative flex" @mouseenter="mainLinkEnter" @mouseleave="mainLinkLeave">
    <Laser class="main-link__laser self-center w-full h-full"></Laser>
    <div class="ml-12 main-link__label absolute">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Laser from "@/components/Laser/Laser.vue";
import { TweenLite } from "gsap";

const ANIMATION_SPEED = 0.15;

export default {
  name: "MainLink",
  components: {
    Laser
  },
  methods: {
    mainLinkEnter(e) {
      TweenLite.to(
        e.target.querySelector(".main-link__label"),
        ANIMATION_SPEED,
        {
          x: "50"
        }
      );

      TweenLite.to(
        e.target.querySelector(".main-link__laser"),
        ANIMATION_SPEED,
        {
          scaleX: "1",
          transformOrigin: "0% 0%"
        }
      );
    },
    mainLinkLeave(e) {
      TweenLite.to(
        e.target.querySelector(".main-link__label"),
        ANIMATION_SPEED,
        {
          x: "0"
        }
      );

      TweenLite.to(
        e.target.querySelector(".main-link__laser"),
        ANIMATION_SPEED,
        {
          scaleX: "0"
        }
      );
    }
  }
};
</script>

<style lang="scss">
.main-link {
  &__laser {
    transform: scaleX(0);
  }
}
</style>